import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';

import { RegistroImpuestosPredialStore } from '../../stores';

import { SubformPanel } from '../shared';
import CommentsSection from '../shared/CommentsSection';
import { CuentasSubform } from './CuentasSubform';
import { DescuentosSubform } from './DescuentosSubform';
import { IngresosSubform } from './IngresosSubform';

interface RegistroImpuestosPredialFormProps {
    registroImpuestosPredialStore?: RegistroImpuestosPredialStore;
}

@inject('aprobacionStore')
@inject('registroImpuestosPredialStore')
@observer
export class RegistroImpuestosPredialForm extends Component<RegistroImpuestosPredialFormProps> {
    handleNewCommentEdit = (comment: string) => {
        const { registroImpuestosPredialStore } = this.props;
        registroImpuestosPredialStore!.updateNewComment(comment);
    };

    render() {
        const {
            registroImpuestos,
            isReadonly,
            newComment,
            mode
        } = this.props.registroImpuestosPredialStore!;
        const { ingresos, cuentas, descuentos, estado, comentarios } = registroImpuestos;

        return (
            <>
                <SubformPanel title="FORMATO 1" showCheckMark={ingresos.isSaved} key="1">
                    <IngresosSubform isReadonly={isReadonly} />
                </SubformPanel>
                <SubformPanel title="FORMATO 2" showCheckMark={cuentas.isSaved} key="2">
                    <CuentasSubform isReadonly={isReadonly} />
                </SubformPanel>
                <SubformPanel title="FORMATO 3" showCheckMark={descuentos.isSaved} key="3">
                    <DescuentosSubform isReadonly={isReadonly} />
                </SubformPanel>
                {(estado === 'Capturado' ||
                    estado === 'Rechazado' ||
                    estado === 'Aprobado' ||
                    estado === 'Corregido') && (
                    <CommentsSection
                        comments={comentarios}
                        newComment={newComment}
                        isEditable={estado === 'Rechazado' || mode === 'aprobaciones'}
                        captura={mode === 'captura'}
                        onNewCommentEdit={this.handleNewCommentEdit}
                    />
                )}
            </>
        );
    }
}
